<mat-card class="mt-10">
  <mat-progress-bar
    mode="indeterminate"
    *ngIf="loadReminders"
    class="progress-bar">
  </mat-progress-bar>
  <mat-card-header>
    <mat-card-title>
      <h5>Sent reminders</h5>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <table mat-table [dataSource]="emailReminders">
      <ng-container *ngFor="let column of reminderCols" [matColumnDef]="column.columnDef">
        <th mat-header-cell *matHeaderCellDef>{{ column.header }}</th>
        <td mat-cell *matCellDef="let row">{{ column.cell(row) }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="reminderDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: reminderDisplayedColumns;"></tr>
    </table>
  </mat-card-content>
</mat-card>
